<!--suppress ALL -->
<script lang="ts">
  import {typePembayarans} from '../../../util/PluralVariabels';
  import {Component, Vue, Prop} from 'annotation';
  import {cloneArray} from "../../../util/Underscore";
  import AppConfig from "../../../AppConfig";

  import GField from '../common/field/GField.vue';
  import GSelect from '../common/select/GSelect.vue';

  @Component
  export default class TypePembayaranSelect extends Vue {

    @Prop({default: typePembayarans[0], type: String})
    private typePembayaran: string;

    @Prop({default: false, type: Boolean})
    public skipLabel: boolean;

    @Prop({default: true, type: Boolean})

    public isFullwidth: boolean;

    @Prop({default: false, type: Boolean})
    public disabled: boolean;

    @Prop({
      default: () => AppConfig.getVm().$t('label.type_pay').toString(),
      type: String
    })
    public label: string;

    @Prop({
      default: () => {
        return AppConfig.getVm().$t('placeholder.select_type_pay').toString();
      }, type: String
    })
    public placeholder: string;

    @Prop({type: String, default: ""})
    public message: string;

    public onSelectTypeTugas(param: string) {
      const typePembayaran = param || typePembayarans[0];

      this.$emit('update:typePembayaran', typePembayaran);
    }

    public render(createElement: Function) {
      const {$t, typePembayaran, isFullwidth, label, message, type} = this;

      const mainAttr: any = {
        attrs: {disabled: this.disabled},
        props: {
          value: typePembayaran, isFullwidth,
          placeholder: `${$t('label.choose')} ${label}`
        },
        on: {change: this.onSelectTypeTugas}
      };

      const main: any = createElement(GSelect, mainAttr, cloneArray(typePembayarans).map((item: any) => {
        const option: any = {attrs: {value: item}};

        return createElement('option', option, item);
      }));

      if (this.skipLabel) {
        return main;
      }

      return createElement(GField, {props: {label, message, type}}, [main]);
    }
  }
</script>
